import type {ReactNode} from 'react';
import React, {useEffect, useState} from 'react';

import {ThemeContext} from './ThemeProviderContext';

export const ThemeProvider: React.FC<{children: ReactNode}> = ({children}) => {
  const [isDark, setIsDark] = useState<boolean>(() => {
    if (typeof window === 'undefined') {
      return false;
    }

    const saved = localStorage.getItem('theme');

    if (saved === 'dark') {
      return true;
    }
    if (saved === 'light') {
      return false;
    }

    //no saved preference: use system
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  //apply the theme class and persist to localStorage
  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark]);

  //listen for system theme changes *only if no preference is saved*
  useEffect(() => {
    const saved = localStorage.getItem('theme');
    if (saved) {
      return;
    } //don't override manual choice

    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const listener = (e: MediaQueryListEvent) => {
      setIsDark(e.matches);
    };
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, []);

  const toggleDarkMode = () => {
    setIsDark((prev) => !prev);
  };

  return (
    <ThemeContext.Provider value={{isDark, toggleDarkMode}}>
      {children}
    </ThemeContext.Provider>
  );
};
